<a [class]="'link ' + fromSize(size) + ' ' + fromVisibility(visibility)"
   [class._disabled]="disabled" [href]="href" [target]="target">
    <ng-content></ng-content>
</a>
